/* tslint:disable */
/* eslint-disable */
/**
 * Retrieve API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface AndCondition
 */
export interface AndCondition {
    /**
     * 
     * @type {string}
     * @memberof AndCondition
     */
    'type'?: AndConditionTypeEnum;
    /**
     * 
     * @type {Array<AndConditionConditionsInner>}
     * @memberof AndCondition
     */
    'conditions'?: Array<AndConditionConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum AndConditionTypeEnum {
    AND = 'and'
}

/**
 * @type AndConditionConditionsInner
 * @export
 */
export type AndConditionConditionsInner = { type: 'and' } & AndCondition | { type: 'contains_any_of' } & ContainsAnyOfCondition | { type: 'eq' } & EqualsCondition | { type: 'gt' } & GreaterThanCondition | { type: 'gte' } & GreaterThanOrEqualsCondition | { type: 'is_in' } & IsInCondition | { type: 'is_null' } & IsNullCondition | { type: 'like' } & LikeCondition | { type: 'lt' } & LessThanCondition | { type: 'lte' } & LessThanOrEqualsCondition | { type: 'multiple_of' } & MultipleOfCondition | { type: 'ne' } & NotEqualsCondition | { type: 'not' } & NotCondition | { type: 'not_in' } & NotInCondition | { type: 'or' } & OrCondition;

/**
 * @type Condition
 * @export
 */
export type Condition = { type: 'and' } & AndCondition | { type: 'contains_any_of' } & ContainsAnyOfCondition | { type: 'eq' } & EqualsCondition | { type: 'gt' } & GreaterThanCondition | { type: 'gte' } & GreaterThanOrEqualsCondition | { type: 'is_in' } & IsInCondition | { type: 'is_null' } & IsNullCondition | { type: 'like' } & LikeCondition | { type: 'lt' } & LessThanCondition | { type: 'lte' } & LessThanOrEqualsCondition | { type: 'multiple_of' } & MultipleOfCondition | { type: 'ne' } & NotEqualsCondition | { type: 'not' } & NotCondition | { type: 'not_in' } & NotInCondition | { type: 'or' } & OrCondition;

/**
 * 
 * @export
 * @interface ContainsAnyOfCondition
 */
export interface ContainsAnyOfCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof ContainsAnyOfCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof ContainsAnyOfCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof ContainsAnyOfCondition
     */
    'type'?: ContainsAnyOfConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContainsAnyOfConditionTypeEnum {
    CONTAINS_ANY_OF = 'contains_any_of'
}

/**
 * 
 * @export
 * @interface EntityFeatureValue
 */
export interface EntityFeatureValue {
    /**
     * 
     * @type {string}
     * @memberof EntityFeatureValue
     */
    'key': string;
    /**
     * 
     * @type {FeatureType}
     * @memberof EntityFeatureValue
     */
    'type': FeatureType;
    /**
     * 
     * @type {string}
     * @memberof EntityFeatureValue
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EntityFeatureValue
     */
    'description'?: string | null;
    /**
     * 
     * @type {EntityFeatureValueQuery}
     * @memberof EntityFeatureValue
     */
    'query': EntityFeatureValueQuery;
    /**
     * 
     * @type {any}
     * @memberof EntityFeatureValue
     */
    'value'?: any;
    /**
     * 
     * @type {string}
     * @memberof EntityFeatureValue
     */
    'timestamp'?: string | null;
}


/**
 * 
 * @export
 * @interface EntityFeatureValueQuery
 */
export interface EntityFeatureValueQuery {
    /**
     * 
     * @type {string}
     * @memberof EntityFeatureValueQuery
     */
    'event': string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityFeatureValueQuery
     */
    'window_hop': number | null;
    /**
     * 
     * @type {number}
     * @memberof EntityFeatureValueQuery
     */
    'window_length': number | null;
}
/**
 * 
 * @export
 * @interface EntityType
 */
export interface EntityType {
}
/**
 * 
 * @export
 * @interface EqualsCondition
 */
export interface EqualsCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof EqualsCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof EqualsCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof EqualsCondition
     */
    'type'?: EqualsConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EqualsConditionTypeEnum {
    EQ = 'eq'
}

/**
 * 
 * @export
 * @interface EventFilterExecutionResultsResponse
 */
export interface EventFilterExecutionResultsResponse {
    /**
     * List of events
     * @type {Array<EventResponse>}
     * @memberof EventFilterExecutionResultsResponse
     */
    'events': Array<EventResponse>;
    /**
     * 
     * @type {number}
     * @memberof EventFilterExecutionResultsResponse
     */
    'total_count'?: number | null;
    /**
     * Status of the query execution
     * @type {QueryStatus}
     * @memberof EventFilterExecutionResultsResponse
     */
    'status': QueryStatus;
    /**
     * 
     * @type {string}
     * @memberof EventFilterExecutionResultsResponse
     */
    'error_message'?: string | null;
}


/**
 * 
 * @export
 * @interface EventFilterRequest
 */
export interface EventFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof EventFilterRequest
     */
    'event_type': string;
    /**
     * 
     * @type {number}
     * @memberof EventFilterRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventFilterRequest
     */
    'environment': EventFilterRequestEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof EventFilterRequest
     */
    'start_timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof EventFilterRequest
     */
    'end_timestamp': string;
    /**
     * 
     * @type {EventFilterRequestFilterCondition}
     * @memberof EventFilterRequest
     */
    'filter_condition'?: EventFilterRequestFilterCondition | null;
    /**
     * 
     * @type {string}
     * @memberof EventFilterRequest
     */
    'entity_id'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventFilterRequestEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}

/**
 * @type EventFilterRequestFilterCondition
 * @export
 */
export type EventFilterRequestFilterCondition = { type: 'and' } & AndCondition | { type: 'contains_any_of' } & ContainsAnyOfCondition | { type: 'eq' } & EqualsCondition | { type: 'gt' } & GreaterThanCondition | { type: 'gte' } & GreaterThanOrEqualsCondition | { type: 'is_in' } & IsInCondition | { type: 'is_null' } & IsNullCondition | { type: 'like' } & LikeCondition | { type: 'lt' } & LessThanCondition | { type: 'lte' } & LessThanOrEqualsCondition | { type: 'multiple_of' } & MultipleOfCondition | { type: 'ne' } & NotEqualsCondition | { type: 'not' } & NotCondition | { type: 'not_in' } & NotInCondition | { type: 'or' } & OrCondition;

/**
 * Response model for the events endpoint.  Does not include nested entities, but has: - entity _type - entity _id - entity _display_symbol  for each entity in the payload.
 * @export
 * @interface EventResponse
 */
export interface EventResponse {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EventResponse
     */
    'payload': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof EventResponse
     */
    'event_type': string;
    /**
     * 
     * @type {string}
     * @memberof EventResponse
     */
    'ingestion_timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof EventResponse
     */
    'environment': EventResponseEnvironmentEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EventResponseEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum FeatureType {
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    STRING = 'string',
    DATETIME = 'datetime',
    ARRAY = 'array',
    OBJECT = 'object',
    DATE = 'date'
}


/**
 * 
 * @export
 * @interface FieldOperand
 */
export interface FieldOperand {
    /**
     * 
     * @type {string}
     * @memberof FieldOperand
     */
    'type'?: FieldOperandTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldOperand
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum FieldOperandTypeEnum {
    FIELD = 'field'
}

/**
 * 
 * @export
 * @interface GreaterThanCondition
 */
export interface GreaterThanCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanCondition
     */
    'type'?: GreaterThanConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanConditionTypeEnum {
    GT = 'gt'
}

/**
 * 
 * @export
 * @interface GreaterThanOrEqualsCondition
 */
export interface GreaterThanOrEqualsCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanOrEqualsCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanOrEqualsCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanOrEqualsCondition
     */
    'type'?: GreaterThanOrEqualsConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanOrEqualsConditionTypeEnum {
    GTE = 'gte'
}

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface IsInCondition
 */
export interface IsInCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof IsInCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof IsInCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof IsInCondition
     */
    'type'?: IsInConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum IsInConditionTypeEnum {
    IS_IN = 'is_in'
}

/**
 * 
 * @export
 * @interface IsNullCondition
 */
export interface IsNullCondition {
    /**
     * 
     * @type {string}
     * @memberof IsNullCondition
     */
    'type'?: IsNullConditionTypeEnum;
    /**
     * 
     * @type {Value}
     * @memberof IsNullCondition
     */
    'value': Value;
}

/**
    * @export
    * @enum {string}
    */
export enum IsNullConditionTypeEnum {
    IS_NULL = 'is_null'
}

/**
 * 
 * @export
 * @interface LessThanCondition
 */
export interface LessThanCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanCondition
     */
    'type'?: LessThanConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanConditionTypeEnum {
    LT = 'lt'
}

/**
 * 
 * @export
 * @interface LessThanOrEqualsCondition
 */
export interface LessThanOrEqualsCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanOrEqualsCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanOrEqualsCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanOrEqualsCondition
     */
    'type'?: LessThanOrEqualsConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanOrEqualsConditionTypeEnum {
    LTE = 'lte'
}

/**
 * @type Lhs
 * @export
 */
export type Lhs = { type: 'field' } & FieldOperand | { type: 'literal' } & LiteralOperand;

/**
 * 
 * @export
 * @interface LikeCondition
 */
export interface LikeCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof LikeCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LikeCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LikeCondition
     */
    'type'?: LikeConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LikeConditionTypeEnum {
    LIKE = 'like'
}

/**
 * 
 * @export
 * @interface LiteralOperand
 */
export interface LiteralOperand {
    /**
     * 
     * @type {string}
     * @memberof LiteralOperand
     */
    'type'?: LiteralOperandTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiteralOperand
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum LiteralOperandTypeEnum {
    LITERAL = 'literal'
}

/**
 * 
 * @export
 * @interface MultipleOfCondition
 */
export interface MultipleOfCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof MultipleOfCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof MultipleOfCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof MultipleOfCondition
     */
    'type'?: MultipleOfConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MultipleOfConditionTypeEnum {
    MULTIPLE_OF = 'multiple_of'
}

/**
 * 
 * @export
 * @interface NotCondition
 */
export interface NotCondition {
    /**
     * 
     * @type {string}
     * @memberof NotCondition
     */
    'type'?: NotConditionTypeEnum;
    /**
     * 
     * @type {Condition}
     * @memberof NotCondition
     */
    'condition': Condition;
}

/**
    * @export
    * @enum {string}
    */
export enum NotConditionTypeEnum {
    NOT = 'not'
}

/**
 * 
 * @export
 * @interface NotEqualsCondition
 */
export interface NotEqualsCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof NotEqualsCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof NotEqualsCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof NotEqualsCondition
     */
    'type'?: NotEqualsConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NotEqualsConditionTypeEnum {
    NE = 'ne'
}

/**
 * 
 * @export
 * @interface NotInCondition
 */
export interface NotInCondition {
    /**
     * 
     * @type {Lhs}
     * @memberof NotInCondition
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof NotInCondition
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof NotInCondition
     */
    'type'?: NotInConditionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NotInConditionTypeEnum {
    NOT_IN = 'not_in'
}

/**
 * 
 * @export
 * @interface OrCondition
 */
export interface OrCondition {
    /**
     * 
     * @type {string}
     * @memberof OrCondition
     */
    'type'?: OrConditionTypeEnum;
    /**
     * 
     * @type {Array<AndConditionConditionsInner>}
     * @memberof OrCondition
     */
    'conditions'?: Array<AndConditionConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrConditionTypeEnum {
    OR = 'or'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum QueryStatus {
    QUEUED = 'queued',
    RUNNING = 'running',
    SUCCEEDED = 'succeeded',
    FAILED = 'failed',
    TIMEOUT = 'timeout'
}


/**
 * 
 * @export
 * @interface QuerySubmissionResponse
 */
export interface QuerySubmissionResponse {
    /**
     * Unique execution token for polling execution results
     * @type {string}
     * @memberof QuerySubmissionResponse
     */
    'execution_token': string;
    /**
     * Initial status is always \'queued\'
     * @type {QueryStatus}
     * @memberof QuerySubmissionResponse
     */
    'status'?: QueryStatus;
    /**
     * When query was submitted
     * @type {string}
     * @memberof QuerySubmissionResponse
     */
    'created_at': string;
}


/**
 * 
 * @export
 * @interface ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
 */
export interface ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet {
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'address_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'address_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'zipcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    'country'?: string;
}
/**
 * @type Rhs
 * @export
 */
export type Rhs = { type: 'field' } & FieldOperand | { type: 'literal' } & LiteralOperand;

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * @type Value
 * @export
 */
export type Value = { type: 'field' } & FieldOperand | { type: 'literal' } & LiteralOperand;


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve event by id
         * @param {string} id 
         * @param {string} eventType 
         * @param {GetEventByIdEventsEventTypeIdGetEnvironmentEnum} environment 
         * @param {string | null} [startTimestamp] 
         * @param {string | null} [endTimestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventByIdEventsEventTypeIdGet: async (id: string, eventType: string, environment: GetEventByIdEventsEventTypeIdGetEnvironmentEnum, startTimestamp?: string | null, endTimestamp?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventByIdEventsEventTypeIdGet', 'id', id)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('getEventByIdEventsEventTypeIdGet', 'eventType', eventType)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('getEventByIdEventsEventTypeIdGet', 'environment', environment)
            const localVarPath = `/events/{event_type}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"event_type"}}`, encodeURIComponent(String(eventType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (startTimestamp !== undefined) {
                localVarQueryParameter['start_timestamp'] = (startTimestamp as any instanceof Date) ?
                    (startTimestamp as any).toISOString() :
                    startTimestamp;
            }

            if (endTimestamp !== undefined) {
                localVarQueryParameter['end_timestamp'] = (endTimestamp as any instanceof Date) ?
                    (endTimestamp as any).toISOString() :
                    endTimestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Event Filter Query
         * @param {string} executionToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventFilterQueryEventsQueryExecutionTokenGet: async (executionToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionToken' is not null or undefined
            assertParamExists('getEventFilterQueryEventsQueryExecutionTokenGet', 'executionToken', executionToken)
            const localVarPath = `/events/query/{execution_token}`
                .replace(`{${"execution_token"}}`, encodeURIComponent(String(executionToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve events
         * @param {string} startTimestamp 
         * @param {string} endTimestamp 
         * @param {string} eventType 
         * @param {GetEventsEventsGetEnvironmentEnum} environment 
         * @param {string | null} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsEventsGet: async (startTimestamp: string, endTimestamp: string, eventType: string, environment: GetEventsEventsGetEnvironmentEnum, entityId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTimestamp' is not null or undefined
            assertParamExists('getEventsEventsGet', 'startTimestamp', startTimestamp)
            // verify required parameter 'endTimestamp' is not null or undefined
            assertParamExists('getEventsEventsGet', 'endTimestamp', endTimestamp)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('getEventsEventsGet', 'eventType', eventType)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('getEventsEventsGet', 'environment', environment)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startTimestamp !== undefined) {
                localVarQueryParameter['start_timestamp'] = (startTimestamp as any instanceof Date) ?
                    (startTimestamp as any).toISOString() :
                    startTimestamp;
            }

            if (endTimestamp !== undefined) {
                localVarQueryParameter['end_timestamp'] = (endTimestamp as any instanceof Date) ?
                    (endTimestamp as any).toISOString() :
                    endTimestamp;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reveal a sensitive field for an event
         * @param {string} id 
         * @param {string} eventType 
         * @param {string} field 
         * @param {RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum} environment 
         * @param {string | null} [timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealEventFieldEventsEventTypeIdRevealFieldGet: async (id: string, eventType: string, field: string, environment: RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum, timestamp?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revealEventFieldEventsEventTypeIdRevealFieldGet', 'id', id)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('revealEventFieldEventsEventTypeIdRevealFieldGet', 'eventType', eventType)
            // verify required parameter 'field' is not null or undefined
            assertParamExists('revealEventFieldEventsEventTypeIdRevealFieldGet', 'field', field)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('revealEventFieldEventsEventTypeIdRevealFieldGet', 'environment', environment)
            const localVarPath = `/events/{event_type}/{id}/reveal/{field}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"event_type"}}`, encodeURIComponent(String(eventType)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = (timestamp as any instanceof Date) ?
                    (timestamp as any).toISOString() :
                    timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit async event filter query
         * @param {EventFilterRequest} eventFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEventFilterQueryEventsQueryPost: async (eventFilterRequest: EventFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventFilterRequest' is not null or undefined
            assertParamExists('submitEventFilterQueryEventsQueryPost', 'eventFilterRequest', eventFilterRequest)
            const localVarPath = `/events/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve event by id
         * @param {string} id 
         * @param {string} eventType 
         * @param {GetEventByIdEventsEventTypeIdGetEnvironmentEnum} environment 
         * @param {string | null} [startTimestamp] 
         * @param {string | null} [endTimestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventByIdEventsEventTypeIdGet(id: string, eventType: string, environment: GetEventByIdEventsEventTypeIdGetEnvironmentEnum, startTimestamp?: string | null, endTimestamp?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventByIdEventsEventTypeIdGet(id, eventType, environment, startTimestamp, endTimestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventByIdEventsEventTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Event Filter Query
         * @param {string} executionToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventFilterQueryEventsQueryExecutionTokenGet(executionToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventFilterExecutionResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventFilterQueryEventsQueryExecutionTokenGet(executionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventFilterQueryEventsQueryExecutionTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve events
         * @param {string} startTimestamp 
         * @param {string} endTimestamp 
         * @param {string} eventType 
         * @param {GetEventsEventsGetEnvironmentEnum} environment 
         * @param {string | null} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsEventsGet(startTimestamp: string, endTimestamp: string, eventType: string, environment: GetEventsEventsGetEnvironmentEnum, entityId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsEventsGet(startTimestamp, endTimestamp, eventType, environment, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventsEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reveal a sensitive field for an event
         * @param {string} id 
         * @param {string} eventType 
         * @param {string} field 
         * @param {RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum} environment 
         * @param {string | null} [timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revealEventFieldEventsEventTypeIdRevealFieldGet(id: string, eventType: string, field: string, environment: RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum, timestamp?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revealEventFieldEventsEventTypeIdRevealFieldGet(id, eventType, field, environment, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.revealEventFieldEventsEventTypeIdRevealFieldGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit async event filter query
         * @param {EventFilterRequest} eventFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitEventFilterQueryEventsQueryPost(eventFilterRequest: EventFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitEventFilterQueryEventsQueryPost(eventFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.submitEventFilterQueryEventsQueryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve event by id
         * @param {EventsApiGetEventByIdEventsEventTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventByIdEventsEventTypeIdGet(requestParameters: EventsApiGetEventByIdEventsEventTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventResponse> {
            return localVarFp.getEventByIdEventsEventTypeIdGet(requestParameters.id, requestParameters.eventType, requestParameters.environment, requestParameters.startTimestamp, requestParameters.endTimestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Event Filter Query
         * @param {EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventFilterQueryEventsQueryExecutionTokenGet(requestParameters: EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventFilterExecutionResultsResponse> {
            return localVarFp.getEventFilterQueryEventsQueryExecutionTokenGet(requestParameters.executionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve events
         * @param {EventsApiGetEventsEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsEventsGet(requestParameters: EventsApiGetEventsEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventResponse>> {
            return localVarFp.getEventsEventsGet(requestParameters.startTimestamp, requestParameters.endTimestamp, requestParameters.eventType, requestParameters.environment, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reveal a sensitive field for an event
         * @param {EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealEventFieldEventsEventTypeIdRevealFieldGet(requestParameters: EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseRevealEventFieldEventsEventTypeIdRevealFieldGet> {
            return localVarFp.revealEventFieldEventsEventTypeIdRevealFieldGet(requestParameters.id, requestParameters.eventType, requestParameters.field, requestParameters.environment, requestParameters.timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit async event filter query
         * @param {EventsApiSubmitEventFilterQueryEventsQueryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEventFilterQueryEventsQueryPost(requestParameters: EventsApiSubmitEventFilterQueryEventsQueryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuerySubmissionResponse> {
            return localVarFp.submitEventFilterQueryEventsQueryPost(requestParameters.eventFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getEventByIdEventsEventTypeIdGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventByIdEventsEventTypeIdGetRequest
 */
export interface EventsApiGetEventByIdEventsEventTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventByIdEventsEventTypeIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventByIdEventsEventTypeIdGet
     */
    readonly eventType: string

    /**
     * 
     * @type {'sandbox' | 'live'}
     * @memberof EventsApiGetEventByIdEventsEventTypeIdGet
     */
    readonly environment: GetEventByIdEventsEventTypeIdGetEnvironmentEnum

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventByIdEventsEventTypeIdGet
     */
    readonly startTimestamp?: string | null

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventByIdEventsEventTypeIdGet
     */
    readonly endTimestamp?: string | null
}

/**
 * Request parameters for getEventFilterQueryEventsQueryExecutionTokenGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest
 */
export interface EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventFilterQueryEventsQueryExecutionTokenGet
     */
    readonly executionToken: string
}

/**
 * Request parameters for getEventsEventsGet operation in EventsApi.
 * @export
 * @interface EventsApiGetEventsEventsGetRequest
 */
export interface EventsApiGetEventsEventsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventsEventsGet
     */
    readonly startTimestamp: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventsEventsGet
     */
    readonly endTimestamp: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventsEventsGet
     */
    readonly eventType: string

    /**
     * 
     * @type {'sandbox' | 'live'}
     * @memberof EventsApiGetEventsEventsGet
     */
    readonly environment: GetEventsEventsGetEnvironmentEnum

    /**
     * 
     * @type {string}
     * @memberof EventsApiGetEventsEventsGet
     */
    readonly entityId?: string | null
}

/**
 * Request parameters for revealEventFieldEventsEventTypeIdRevealFieldGet operation in EventsApi.
 * @export
 * @interface EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest
 */
export interface EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    readonly eventType: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    readonly field: string

    /**
     * 
     * @type {'sandbox' | 'live'}
     * @memberof EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    readonly environment: RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum

    /**
     * 
     * @type {string}
     * @memberof EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGet
     */
    readonly timestamp?: string | null
}

/**
 * Request parameters for submitEventFilterQueryEventsQueryPost operation in EventsApi.
 * @export
 * @interface EventsApiSubmitEventFilterQueryEventsQueryPostRequest
 */
export interface EventsApiSubmitEventFilterQueryEventsQueryPostRequest {
    /**
     * 
     * @type {EventFilterRequest}
     * @memberof EventsApiSubmitEventFilterQueryEventsQueryPost
     */
    readonly eventFilterRequest: EventFilterRequest
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve event by id
     * @param {EventsApiGetEventByIdEventsEventTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventByIdEventsEventTypeIdGet(requestParameters: EventsApiGetEventByIdEventsEventTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventByIdEventsEventTypeIdGet(requestParameters.id, requestParameters.eventType, requestParameters.environment, requestParameters.startTimestamp, requestParameters.endTimestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Event Filter Query
     * @param {EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventFilterQueryEventsQueryExecutionTokenGet(requestParameters: EventsApiGetEventFilterQueryEventsQueryExecutionTokenGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventFilterQueryEventsQueryExecutionTokenGet(requestParameters.executionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve events
     * @param {EventsApiGetEventsEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventsEventsGet(requestParameters: EventsApiGetEventsEventsGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventsEventsGet(requestParameters.startTimestamp, requestParameters.endTimestamp, requestParameters.eventType, requestParameters.environment, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reveal a sensitive field for an event
     * @param {EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public revealEventFieldEventsEventTypeIdRevealFieldGet(requestParameters: EventsApiRevealEventFieldEventsEventTypeIdRevealFieldGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).revealEventFieldEventsEventTypeIdRevealFieldGet(requestParameters.id, requestParameters.eventType, requestParameters.field, requestParameters.environment, requestParameters.timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit async event filter query
     * @param {EventsApiSubmitEventFilterQueryEventsQueryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public submitEventFilterQueryEventsQueryPost(requestParameters: EventsApiSubmitEventFilterQueryEventsQueryPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).submitEventFilterQueryEventsQueryPost(requestParameters.eventFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetEventByIdEventsEventTypeIdGetEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEventsEventsGetEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum RevealEventFieldEventsEventTypeIdRevealFieldGetEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}


/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve features for entity. Use __global__ as entity_type to retrieve global events.
         * @param {EntityType} entityType 
         * @param {string} entityId 
         * @param {GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet: async (entityType: EntityType, entityId: string, environment: GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet', 'entityId', entityId)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet', 'environment', environment)
            const localVarPath = `/features/{environment}/{entity_type}/{entity_id}`
                .replace(`{${"entity_type"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve features for entity. Use __global__ as entity_type to retrieve global events.
         * @param {EntityType} entityType 
         * @param {string} entityId 
         * @param {GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(entityType: EntityType, entityId: string, environment: GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityFeatureValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(entityType, entityId, environment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve features for entity. Use __global__ as entity_type to retrieve global events.
         * @param {FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(requestParameters: FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityFeatureValue>> {
            return localVarFp.getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, requestParameters.environment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet operation in FeaturesApi.
 * @export
 * @interface FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest
 */
export interface FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest {
    /**
     * 
     * @type {EntityType}
     * @memberof FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet
     */
    readonly entityType: EntityType

    /**
     * 
     * @type {string}
     * @memberof FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'sandbox' | 'live'}
     * @memberof FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet
     */
    readonly environment: GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum
}

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve features for entity. Use __global__ as entity_type to retrieve global events.
     * @param {FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(requestParameters: FeaturesApiGetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).getFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, requestParameters.environment, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetFeatureByEntityFeaturesEnvironmentEntityTypeEntityIdGetEnvironmentEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}


